import React from "react";
import { Control, FieldErrors } from "react-hook-form";
import { CodedProperty, ensure, FormMultiselectDropdown, mapToDropdownOption } from "sprint-common-web";

import { useDubbings } from "../../../../common/data/data-hooks/useDubbings";
import { useCreateOrder } from "../common/provider/useCreateOrder";
import { OrderSoundtrackItem } from "../types/OrderSoundtrackItem";

interface OrderSoundtracksSelectorProps {
    label: string;
    name: string;
    control: Control;
    errors: FieldErrors;
    dependsOn: string[];
    testId?: string;
}

export const OrderSoundtracksSelector: React.FC<OrderSoundtracksSelectorProps> = ({
    label,
    name,
    control,
    errors,
    dependsOn,
    testId
}: OrderSoundtracksSelectorProps) => {
    const { data: dubbingLanguages, isLoading } = useDubbings();
    const { setSoundtracks } = useCreateOrder();

    const handleSelectedOption = (ids: string[]) => {
        const languageArray: CodedProperty[] = [];

        ids.forEach((id) => {
            const dubbingLanguage = dubbingLanguages?.find((item) => item.id === id);
            ensure(dubbingLanguage);
            languageArray.push(dubbingLanguage);
        });

        const indexedLanguageArray = languageArray.map(
            (item, index): OrderSoundtrackItem => ({
                ...item,
                index: index + 1
            })
        );

        setSoundtracks(indexedLanguageArray);
    };

    return (
        <FormMultiselectDropdown
            label={label}
            placeholder="Search and select audio tracks"
            name={name}
            options={dubbingLanguages?.map((item) => mapToDropdownOption(item)) ?? []}
            control={control}
            errors={errors}
            rules={{ required: { message: "Select soundtracks", value: true } }}
            dependsOn={dependsOn}
            disabled={isLoading}
            onChange={handleSelectedOption}
            testId={testId}
        />
    );
};
